module.exports = __webpack_public_path__ + "img/slide6.656a73fc.jpg";